import request from './request';

export const periodeService = {
  // Récupérer toutes les périodes
  getAll: async () => {
    try {
      const response = await request.get('/periodes');
      console.log('Périodes récupérées avec succès:', response);
      return response;
    } catch (error) {
      console.error('Erreur lors de la récupération des périodes:', error);
      throw error;
    }
  }
};